import clsx from 'clsx';
import React, {ReactElement} from 'react';
import {PaymentStatus} from '../../../shared/model/PaymentStatus.model';
import {TransHelper} from '../../../utils/trans-helper';
import styles from './PaymentStatusColored.module.scss';
import {DisbursementStatus} from '../../../shared/model/DisbursementStatus.model';

export const PrefixTrans = TransHelper.getPrefixedTrans('SHARED.PAYMENT.STATUS');

type PaymentStatusColoredProps = {
  status: PaymentStatus | DisbursementStatus;
};

export default function PaymentStatusColored({status}: PaymentStatusColoredProps): ReactElement {

  const classes = clsx(styles.status, {
    [styles.status_success]: status === PaymentStatus.EXECUTED,
    [styles.status_warning]: status === PaymentStatus.CANCELED,
    [styles.status_error]: status === PaymentStatus.REJECTED
  });

  return (
    <div className={classes}>
      <PrefixTrans>{status}</PrefixTrans>
    </div>
  );
}
